"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBSolutionsHeader", {
  enumerable: true,
  get: function get() {
    return _SVBSolutionsHeader.default;
  }
});
var _SVBSolutionsHeader = _interopRequireDefault(require("./src/SVBSolutionsHeader"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }